import React, { ReactNode } from "react";
import styles from "./expirationDialog.module.scss";
import Button from "../../../../Components/Button/button";
import { ButtonTypes, ExpirationTypes } from "../../../../Interfaces/componentTypes";
import useLanguagesHooks from "../../../Languages/setLanguage-hooks";
import { Trans } from "react-i18next";
import { Warning } from "../../../../Assets/Icons";

interface IExpirationDialogProps {
    onClose: () => void;
    type: ExpirationTypes;
    daysLeft?: number; // optional, can show remaining days
    daysAfter?: number; // optional, for paid grace period
}

const ExpirationDialog: React.FC<IExpirationDialogProps> = ({
    onClose,
    type,
    daysLeft,
    daysAfter,
}) => {

    const { t } = useLanguagesHooks();
    let title: string = "";
    let description: ReactNode = "";

    if (type === "demo") {
        title = daysLeft !== undefined && daysLeft < 0 ?
            t('My_Business.Expiration.Demo_Expired.Title')
            :
            t('My_Business.Expiration.Demo_Soon.Title');
        description =
            daysLeft !== undefined && daysLeft <= 0
                ? t('My_Business.Expiration.Demo_Expired.Title')
                :
                <Trans
                    i18nKey="My_Business.Expiration.Demo_Soon.Text"
                    values={{ days: daysLeft }}
                    components={{
                        strong: <span className={styles.daysLeft} />,
                    }}
                />
    } else if (type === "paid") {
        if (daysLeft !== undefined && daysLeft < 0 && daysAfter !== undefined && daysAfter > 5) {
            title = t('My_Business.Expiration.Sub_Expired.Title');
            description = t('My_Business.Expiration.Sub_Expired.Text');
        } else if (daysLeft !== undefined && daysLeft <= 3 && daysLeft >= 0) {
            title = t('My_Business.Expiration.Sub_Soon.Title');
            description =
                <Trans
                    i18nKey="My_Business.Expiration.Sub_Soon.Text"
                    values={{ days: daysLeft }}
                    components={{
                        strong: <span className={styles.daysLeft} />,
                    }}
                />;
        } else if (daysAfter !== undefined && daysAfter > 0 && daysAfter <= 5) {
            title = t('My_Business.Expiration.Sub_Grace.Title');
            description =
                <Trans
                    i18nKey="My_Business.Expiration.Sub_Grace.Text"
                    values={{ days: daysLeft }}
                    components={{
                        strong: <span className={styles.daysAfter} />,
                    }}
                />;
        }
    }

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <img src={Warning} alt='warning.svg' />
                <p>
                    {title}
                </p>
            </div>
            <div className={styles.body}>
                <p className={styles.description}>{description}</p>
                <p className={styles.paymentInfo}>
                    <Trans
                        i18nKey="My_Business.Expiration.Pay"
                        values={{ phone: '+37494173591' }}
                        components={{
                            a: <a href={`tel:+37494173591`} className={styles.phoneLink} />,
                        }}
                    />
                </p>
            </div>
            <div className={styles.buttonRow}>
                <Button
                    buttonType={ButtonTypes.Primery}
                    title={t('Buttons.Ok')}
                    onClick={onClose}
                />

            </div>
        </div>
    );
};

export default ExpirationDialog;
